import codePush from 'react-native-code-push';
import { Platform } from 'react-native';
import config from "./config"
import { createAxios } from "./axios"

const variant = require('../config/env.variant').default;

const mandatoryUpdateMessage = 'JALA App will restart to install the update';
export const codePushCallback = {
  syncStatusChangedCallback: undefined,
  downloadProgressCallback: undefined
};

const codePushCheck = async (force = false) => {
  if (!codePush || variant === 'testing' || __DEV__ || true) return null
  const { APPCENTER_DEPLOYMENT_KEY_IOS, APPCENTER_DEPLOYMENT_KEY_ANDROID } = config()
  return createAxios().get('/ping')
    .then(() => codePush.checkForUpdate(Platform.OS === 'ios' ? APPCENTER_DEPLOYMENT_KEY_IOS : APPCENTER_DEPLOYMENT_KEY_ANDROID))
    .catch((e) => {
      console.warn(e)
      return null;
    })
    .then((remotePackage) => {
      if (remotePackage) {
        const optionalOptions = {
          deploymentKey: Platform.OS === 'ios' ? APPCENTER_DEPLOYMENT_KEY_IOS : APPCENTER_DEPLOYMENT_KEY_ANDROID,
          updateDialog: null,
          checkFrequency: codePush.CheckFrequency.MANUAL,
          installMode: !force ? codePush.InstallMode.ON_NEXT_RESUME : codePush.InstallMode.IMMEDIATE
        };
        const mandatoryOptions = {
          ...optionalOptions,
          updateDialog: { mandatoryUpdateMessage },
          mandatoryInstallMode: codePush.InstallMode.IMMEDIATE,
        };
        if (!force && !remotePackage.isMandatory) {
          codePush.sync(optionalOptions).catch();
        } else {
          codePush.sync(
            {
              ...mandatoryOptions,
              updateDialog: !force && mandatoryOptions.updateDialog
            },
            codePushCallback.syncStatusChangedCallback,
            codePushCallback.downloadProgressCallback
          ).catch();
        }
      }
      return remotePackage;
    });
}

export default codePushCheck;
